"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentNode = getParentNode;
exports.getScrollParent = getScrollParent;
require("core-js/modules/es.regexp.exec.js");
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}
function getScrollParent(element) {
  if (!element) {
    return document.body;
  }
  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
    default:
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var getStyleComputedProps = getStyleComputedProperty(element);
  var overflow = getStyleComputedProps.overflow;
  var overflowX = getStyleComputedProps.overflowX;
  var overflowY = getStyleComputedProps.overflowY;
  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }
  return getScrollParent(getParentNode(element));
}
function getStyleComputedProperty(element) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return css;
}